if ( typeof CollectionTabs !== 'function' ) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const tabs = this.querySelectorAll('.collection-tabs_tab');
      const panels = this.querySelectorAll('.collection-tabs_panel');
      const viewCollectionLink = this.querySelector('.section-heading__actions a');
      const viewCollectionLink2 = this.querySelector('.js-view-collection-link');

      /* Every section's link read "View all" with no destination (complaint 534385/2026).
         Name it after the selected tab, or the section heading when there are no tabs. */
      const nameViewLinks = label => {
        if ( ! label ) return;
        [viewCollectionLink, viewCollectionLink2].forEach(a => { if ( a ) a.setAttribute('aria-label', `View all: ${label}`); });
      };
      const heading = this.querySelector('.section-heading__title');

      tabs.forEach(tab => {

        tab.addEventListener('click', e => {

          e.preventDefault(); 

          tabs.forEach(t => {
            t.classList.remove('active');
            // aria-selected and the roving tabindex live on the button, which is
            // what carries role="tab"; the <li> is presentational.
            const b = t.querySelector('button');
            if (b) { b.setAttribute('aria-selected', 'false'); b.setAttribute('tabindex', '-1'); }
          });
          panels.forEach(panel => {
            panel.classList.remove('active');
            panel.setAttribute('aria-hidden', 'true')
          });

          tab.classList.add('active');
          const activeBtn = tab.querySelector('button');
          if (activeBtn) { activeBtn.setAttribute('aria-selected', 'true'); activeBtn.setAttribute('tabindex', '0'); }

          const targetPanelId = tab.querySelector('button').getAttribute('aria-controls');
          const collectionUrl = tab.querySelector('button').getAttribute('data-collection-url');
          
          if ( collectionUrl && activeBtn ) {
            nameViewLinks(activeBtn.textContent.replace(/\s+/g, ' ').trim());
          }
          if ( viewCollectionLink && collectionUrl ) {
            viewCollectionLink.setAttribute('href', collectionUrl);
          }
          if ( viewCollectionLink2 && collectionUrl ) {
            viewCollectionLink2.setAttribute('href', collectionUrl);
          }

          panels.forEach(panel => {
            if (panel.id === targetPanelId) {
              panel.classList.add('active');
              panel.removeAttribute('aria-hidden');
              const slider = panel.querySelector('css-slider');
              if ( slider ) {
                slider.resetSlider();
              }
            }
          });
        });
      });

      // Left/Right arrows move between tabs, which is how a tablist is expected
      // to behave once the roving tabindex takes the others out of Tab order.
      const tabButtons = Array.from(tabs).map(t => t.querySelector('button')).filter(Boolean);
      tabButtons.forEach((btn, i) => {
        btn.addEventListener('keydown', e => {
          let next = null;
          if (e.key === 'ArrowRight') next = tabButtons[(i + 1) % tabButtons.length];
          else if (e.key === 'ArrowLeft') next = tabButtons[(i - 1 + tabButtons.length) % tabButtons.length];
          else if (e.key === 'Home') next = tabButtons[0];
          else if (e.key === 'End') next = tabButtons[tabButtons.length - 1];
          if (!next) return;
          e.preventDefault();
          next.focus();
          next.click();
        });
      });

      if ( tabButtons.length > 1 ) {
        nameViewLinks(tabButtons[0].textContent.replace(/\s+/g, ' ').trim());
      } else if ( heading ) {
        nameViewLinks(heading.textContent.replace(/\s+/g, ' ').trim());
      }

      if ( tabs.length > 0 && panels.length > 0 ) {
        tabs[0].classList.add('active');
        tabButtons.forEach((b, i) => {
          b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          b.setAttribute('tabindex', i === 0 ? '0' : '-1');
        });
      }
    }

  }

  if ( typeof customElements.get('collection-tabs') == 'undefined' ) {
    customElements.define('collection-tabs', CollectionTabs);
	}

  document.addEventListener('shopify:section:load', (e)=>{
    if ( e.target.classList.contains('mount-collection-tabs') ) {
      e.target.querySelector('collection-tabs')?.init();
    }
  });

}